import * as R from 'ramda'

export const taskStatus: {
  [key: string]: string;
} = {
  ONGONING: 'Ongoing',
  COMPLETE: 'Complete'
}

export const taskStatusKeys = R.keys(taskStatus)
export const taskStatusValues = R.values(taskStatus)

export const taskStatusColor: {
  [key: string]: string;
} = {
  ONGONING: '#62BAF7',
  COMPLETE: '#51A275'
}

export const taskStatusColorKeys = R.keys(taskStatusColor)
export const taskStatusColorValues = R.values(taskStatusColor)

export const taskPriority: {
  [key: string]: string;
} = {
  URGENT: 'Urgent',
  IMPORTANT: 'Important',
  NORMAL: 'Normal'
}

export const taskPriorityKeys = R.keys(taskPriority)
export const taskPriorityValues = R.values(taskPriority)

export const taskPriorityColor: {
  [key: string]: string;
} = {
  URGENT: '#FA5252',
  IMPORTANT: '#62BAF7',
  NORMAL: '#CBCBCB'
}

export const taskPriorityColorKeys = R.keys(taskPriorityColor)
export const taskPriorityColorValues = R.values(taskPriorityColor)

export const taskRelationType: {
  [key: string]: string;
} = {
  POLICY: 'Policy',
  CASE: 'Case',
  ACCOUNT: 'Account'
}

export const taskRelationTypeKeys = R.keys(taskRelationType)
export const taskRelationTypeValues = R.values(taskRelationType)
